export default "__VITE_ASSET__DGdoE6Vq__"